<template>
  <div class="event-detail-popup">
    <div class="block-1 pb-4 mb-4">
      <div class="d-flex align-items-baseline justify-content-between w-100">
        <div>
          <div class="event_id d-flex mb-1">
            {{
              $t("journey-reservation-id", {
                id: event.trip_id,
                reservationId: event.id,
              })
            }}
          </div>
          <div class="journey">
            {{ event.number_of_trips.toString().padStart(2, 0) }}
            {{ $t("journeys") }}
          </div>
        </div>
        <div
          :class="[
            event.type === 'sales-order'
              ? 'Sales-order'
              : event.type === 'draft-sales-order'
              ? 'Draft-sales-order'
              : event.type === 'quotation'
              ? 'Quotation'
              : event.type === 'cancelled'
              ? 'cancelled'
              : event.type === 'waiting-for-approval'
              ? 'waiting-for-approval'
              : '',
          ]"
        >
          {{ $t(event.type) }}
        </div>
      </div>
      <div class="align-self-baseline">
        <img
          :src="require('@/assets/images/icons/cross-icon.svg')"
          alt="cross-icon"
          height="12px"
          width="12px"
          style="cursor: pointer"
          @click.stop="$emit('toggleEventDetailModal')"
        />
      </div>
    </div>
    <div class="block-2 pb-4 mb-4">
      <div class="name">{{ event.client }}</div>
    </div>
    <div class="block-3 pb-4 mb-4">
      <div style="flex: 0.5" class="d-flex align-items-center">
        <div class="icon-cir">
          <img
            src="@/assets/images/icons/setting-icon.svg"
            alt="setting-icon"
          />
        </div>
        <div v-if="event.service">
          {{ isLangRtl ? event.service.arabicName : event.service.name || "" }}
        </div>
      </div>
      <div style="flex: 0.5" class="d-flex align-items-center">
        <div class="icon-cir">
          <img src="@/assets/images/icons/branch-icon.svg" alt="branch-icon" />
        </div>
        <div>{{ event.branch }}</div>
      </div>
      <div
        style="flex: 0.5"
        class="d-flex align-items-center"
        v-b-tooltip.hover="{
          title: $t('employee-name'),
          placement: 'bottom',
        }"
      >
        <div class="icon-cir">
          <img
            src="@/assets/images/icons/operations.svg"
            alt="branch-icon"
            width="16"
            height="16"
          />
        </div>
        <div>{{ event.created_by }}</div>
      </div>
    </div>
    <div class="block-4 pb-4 mb-4">
      <div style="flex: 0.5">
        <div class="d-flex align-items-center mb-1">
          <div class="icon-cir">
            <img src="@/assets/images/icons/clock-icon.svg" alt="clock-icon" />
          </div>
          <div>{{ $t("dates") }}</div>
        </div>
        <div class="date mb-1">
          {{ new Date(event.start_time).toDateString() }}
        </div>
        <div class="date mb-1">
          {{ new Date(event.end_time).toDateString() }}
        </div>
      </div>
      <div style="flex: 0.5">
        <div class="d-flex align-items-center mb-1">
          <div class="icon-cir">
            <img
              src="@/assets/images/icons/location-icon.svg"
              alt="location-icon"
            />
          </div>
          <div>{{ $t("location") }}</div>
        </div>
        <div v-if="event.startLocation" class="location mb-1">
          {{ event.startLocation.name }}
        </div>
        <div v-if="event.endLocation" class="location mb-1">
          {{ event.endLocation.name }}
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <base-button
        cus_style="margin-inline-end:0.25rem"
        variant="secondary"
        @click="$emit('toggleChangeTripStatusModal', event.id)"
      >
        <img src="@/assets/images/icons/cycle-icon.svg" alt="cycle-icon" />
        <span style="margin-inline-start: 0.25rem">
          {{ $t("convert") }}
        </span>
      </base-button>
      <base-button
        cus_style="margin-inline-start:0.25rem"
        variant="primary"
        @click="moveToDetails"
      >
        {{ $t("go-to-details") }}
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["event"],
  emits: ["toggleEventDetailModal", "toggleChangeTripStatusModal"],
  methods: {
    moveToDetails() {
      this.$emit("toggleEventDetailModal");
      this.$router.push(`/reservation/${this.event.id}`).catch(() => {});
    },
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/reservationOperations.json"),
      ar: require("@/services/i18n/locales/ar/reservationOperations.json"),
    },
  },
};
</script>

<style lang="scss" scoped>
.event-detail-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 23;
  min-width: 350px;
  background: var(--color-01);
  border: 1px solid var(--color-14);
  box-shadow: 0px 12px 16px var(--color-38);
  border-radius: 4px;
  padding: 1rem 0.75rem;
  .block-1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--color-14);

    .event_id {
      font-weight: 700;
      font-size: 16px;
      color: var(--color-17);
      margin-inline-end: 0.5rem;
    }
    .journey {
      font-weight: 400;
      font-size: 14px;
      color: var(--color-17);
      margin-inline-end: 0.5rem;
    }
    .status {
      border-radius: 4px;
      font-size: 10px;
      font-weight: 700;
      padding: 0.25rem;
    }
    .Sales-order {
      background: var(--color-19);
      border: 1px solid var(--color-16);
      color: var(--color-12);
    }
    .Draft-sales-order {
      background: var(--color-25);
      border: 1px solid var(--color-26);
      color: var(--color-74);
    }
    .waiting-for-approval {
      background: var(--color-48);
      border: 1px solid var(--color-40);
      color: var(--color-17);
      margin: 0 6px;
    }
    .rescheduled {
      background: var(--color-18);
      border: 1px solid 1px solid var(--color-41);
      color: var(--color-30);
    }
    .cancelled {
      background: var(--color-20);
      border: 1px solid 1px solid var(--color-39);
      color: var(--color-27);
    }
    .pending,
    .Quotation {
      background: var(--color-48);
      border: 1px solid 1px solid var(--color-40);
      color: var(--color-29);
    }
  }
  .block-2 {
    border-bottom: 1px solid var(--color-14);
    .name {
      font-weight: 700;
      font-size: 14px;
      color: var(--color-17);
    }
  }
  .block-3 {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--color-14);
    font-weight: 400;
    font-size: 12px;
    color: var(--color-17);
  }
  .block-4 {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--color-14);
    font-weight: 400;
    font-size: 12px;
    color: var(--color-17);
  }
  .icon-cir {
    background: var(--color-04);
    border-radius: 50%;
    height: 30px;
    width: 30px;
    margin-inline-end: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .date {
    margin-inline-start: 39px;
    font-weight: 700;
    font-size: 12px;
    color: var(--color-17);
  }

  .location {
    margin-inline-start: 39px;
    font-weight: 700;
    font-size: 12px;
    color: var(--color-17);
    position: relative;

    &:before {
      content: "";
      position: absolute;
      background: var(--color-04);
      height: 100%;
      width: 1px;
      left: -24px;
      top: 30%;
      z-index: 1;
    }

    &:last-child:before {
      content: "";
      position: absolute;
      background: var(--color-04);
      height: 50%;
      width: 1px;
      left: -24px;
      top: -10%;
      z-index: 1;
    }

    &:after {
      content: "";
      position: absolute;
      background: var(--color-04);
      height: 5px;
      width: 5px;
      border-radius: 50%;
      left: -26px;
      top: 7px;
      z-index: 1;
    }

    &:last-child:after {
      content: "";
      position: absolute;
      background: var(--color-04);
      border: 1px solid var(--color-04);
      background-clip: content-box;
      padding: 1px;
      height: 7px;
      width: 7px;
      border-radius: 50%;
      left: -27px;
      top: 7px;
      z-index: 1;
    }
  }
}
</style>
